export default "__VITE_ASSET__BVo0dTae__"